import * as AssetSort from '../../constants/AssetSort';
export const DEFAULT_ASSET_QUERY_LIMIT = 24;
export const DEFAULT_ASSET_SORT_VALUE = AssetSort.INSTALL_COUNT_DESC;
export const ASSET_QUERY_FILTER_ORDER = ['offeringTypes', 'planType', 'priceRange', 'portalCompatible', 'tiers', 'minOverallRating', 'hasFreeSupport', 'providers', 'tags'];